<template>
  <div class="card orange">
    <div class="content">
      <div class="header">
        {{ $t('CONTEXT') }}
        <i class="right floated share alternate icon"></i>
      </div>
      <div
        class="meta"
        v-html="
          $t('CONTEXT_META', {
            subject: trigger.subject,
            oldmatch: trigger.regexpOld,
            newmatch: trigger.regexpNew
          })
        "
      ></div>
    </div>

    <div class="primary content">
      <div class="field">
        <label for="subject">{{ $tc('SUBJECT', 1) | capitalize }}</label>
        <input id="subject" type="text" v-model="trigger.subject" />
      </div>
      <regex-field
        v-model="trigger.regexpOld"
        :labelText="$t('OLD', { thing: $t('CONTEXT_TRIGGER_VALUE') })"
      />
      <regex-field
        v-model="trigger.regexpNew"
        :labelText="$t('NEW', { thing: $t('CONTEXT_TRIGGER_VALUE') })"
      />
    </div>

    <slot name="footer"></slot>
  </div>
</template>
<script>
// @flow
import _ from 'lodash'
import { Subject } from 'services'
import { RegexField } from 'ui'

export default {
  name: 'contexttrigger',
  components: { RegexField },
  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          subject: '',
          regexpOld: '',
          regexpNew: ''
        }
      }
    }
  }
}
</script>
